//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Tracks the scheduled attendance status of the individual. */
export const ScheduledAttendanceItemStatus = {
    /** Person's attendance status is pending. */
    Pending: 0,

    /** Person's attendance status is confirmed. */
    Confirmed: 1,

    /** Person's attendance status is declined. */
    Declined: 2,

    /** Person isn't scheduled (they will be in the list of unscheduled resources). */
    Unscheduled: 3
} as const;

/** Tracks the scheduled attendance status of the individual. */
export const ScheduledAttendanceItemStatusDescription: Record<number, string> = {
    0: "Pending",

    1: "Confirmed",

    2: "Declined",

    3: "Unscheduled"
};

/** Tracks the scheduled attendance status of the individual. */
export type ScheduledAttendanceItemStatus = typeof ScheduledAttendanceItemStatus[keyof typeof ScheduledAttendanceItemStatus];
